/**
 * Behavior Class Decorator
 * @param name
 * @constructor
 */
export const Behavior = (name: string) => {
  // @ts-expect-error suppress type error to avoid usage of any instead
  return <T extends PossibleBehaviorConstructor>(constructor: T) => {
    if (typeof elementBehaviors !== 'undefined' && !elementBehaviors.has(name)) {
      elementBehaviors.define(name, constructor);
    }
  };
};
